var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":_vm.name,"adaptive":"","styles":_vm.modalStyles,"height":"auto","scrollable":true}},[_c('div',{staticClass:"close",on:{"click":_vm.closeMe}},[_c('img',{attrs:{"src":require("@/assets/svg/menu-close.svg")}})]),_c('div',{staticClass:"modal-inner",style:(_vm.modalInnerStyles)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }